<template>
  <div id="artinfo" class="artinfo" v-title data-title="艺术头条">
    <van-skeleton :loading="loading" animate title :row="50">
      <pageTitle :extinfo="extinfo"></pageTitle>

      <div class="artinfo-main" v-if="artData.tag != 1">
        <h1 class="h1">{{ artData.title }}</h1>
        <div style="margin: 20px 10px 20px 0;">
          <span class="art-time">来源：{{artData.source}}</span>
          <span class="art-time">{{artData.publishTime}}</span>
          <span class="art-time division">{{artData.browseCount+200}}浏览量</span>
        </div>
        <div class="microsignal" v-if="artData.tag==='1'">
          不爱冗长的文章？艺术微语报呈现短小精悍的先锋资讯。微语，是更精华的短篇信息，编辑极尽简洁地报道艺术资讯，简明扼要、快捷方便。艺术微语报是兰亭艺术头条里的微资讯，包含12条资讯及一条微语录。只需要60秒碎片时间，就可以全局纵览国内外艺术资讯。微语报的更新时间是中午，为您搜罗、精编新锐的艺术、展览、拍卖会等资讯，让您一站式知晓艺术圈内外事。欢迎关注艺术头条-艺术微语报，您的每一次浏览、留言、评论都将帮助我们提升，如果艺术微语报做得还不错，请多转发分享哦！
        </div>
        <div class="info-video" v-if="artData.videoUrl">
          <video :src="artData.videoUrl" controls loop :poster="artData.videoUrl + '?x-oss-process=video/snapshot,t_4,m_fast'"></video>
        </div>
        <div>
          <div ref="articleContent" class="arthtml" v-html="artData.description" @click="previewImage($event)"></div>
        </div>
          <div class="ar-bot" v-if="artData.tag!=='1'">
            <van-image :src="require('@/assets/art-bot.png')" width="341" height="132"></van-image>
          </div>
      </div>
      <div class="micro-info" v-else>
        <div class="micro-title">
          <div class="left">
            <span class="day">{{ day }}</span>
            <span class="month">{{ month }}</span>
            <span class="year">.{{ year }}</span>
            <span class="week division">{{ week }}</span>
          </div>
          <div class="right">
            <span class="nongli">农历{{ month_nl }}月{{ day_nl }}</span>
          </div>
        </div>
        <div class="micro-box">
          <div class="micro-content">
            <div class="today-recommond">作品赏析</div>
            <div class="recommond-img-box" @click="toWorkDetail(artInfo.id)">
              <van-image :src="artInfo.coverUrl+'?x-oss-process=image/resize,l_682'" class="recommond-img" fit="cover" />
            </div>
            <span v-if="artInfo.user">{{artInfo.user.nickname}}作品——{{artInfo.title}}</span>
            <div class="micro-html" v-html="artData.description"></div>
          </div>
        </div>
        <div class="page-view">
          <div class="page-left">
            <div class="pre-page" @click="rollPage(1)"><img :src="require('@/assets/3j_icon.png')">前一天</div>
            <div class="next-page" v-show="pageNoArt != 1" @click="rollPage(-1)" >后一天<img :src="require('@/assets/3j_icon.png')"></div>
          </div>
          <div class="page-right">
            <div class="today-page" v-show="pageNoArt != 1" @click="rollPage(0)">返回今天</div>
          </div>
        </div>
      </div>
      <!-- <div class="artinfo-comment">
        <div class="CommentTitle">
          <div class="right">最新评论{{ total }}</div>
          <div class="page-view">{{ artData.browseCount }}人浏览</div>
          <div class="hx"></div>
          <div class="like-conut">{{ artData.likeCount }}人点赞</div>
        </div>
        <div class="uni-padding-wrap">
          <van-list v-model="listload"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad">
            <div class="uni-comment">
                <comment-item
                  v-for="(item, index) in artCommentList"
                  :key="index"
                  :item="item">
                  </comment-item>
                <van-empty
                  v-if="artCommentList.length === 0"
                  description="暂无评论"/>
              </div>
          </van-list>
        </div>
      </div> -->
      <commen-list v-if="artData.tag != 1" :commentList="artCommentList" :likeTotal="likeTotal" :commentTotal="commentTotal"></commen-list>
      <pageFoot :extinfo="extinfo" v-show="isSuspension"></pageFoot>
      <common-ct  v-if="artData.tag != 1"
        :likeCount="artData.likeCount"
        :commentCount="commentTotal"
        :extinfo="extinfo"
        @share="share" @common="common" @like="like"
      ></common-ct>
    </van-skeleton>
  </div>
</template>

<script>
import { getWorksDetailById } from '@/api/artist'
import { getartInfo, queryCommentList, queryCommentLikeTotal, getRecWorksRandom, queryInformationList } from '@/api/artinfo'
import { getUrlParams, changeTitleClick, wexinShare } from '@/utils/utils'
import { queryShart } from '@/api/user'
import commonCt from '@/components/commonCt/commonCt.vue'
import pageTitle from '@/components/pageTitle/pageTitle.vue'
import pageFoot from '@/components/pageFoot/pageFoot.vue'
import commenList from '@/components/commenList/commenList.vue'
export default {
  name: 'artInfo',
  components: {
    pageTitle,
    pageFoot,
    commonCt,
    commenList
  },
  data () {
    return {
      id: '', // 资讯id
      artData: {
        title: '',
        description: '',
        browseCount: 0,
        likeCount: 0
      },
      artInfo: {
        coverUrl: ''
      },
      artCommentList: [], // 评论列表数据
      pageNo: 0, // 评论页数
      pageSize: 10, // 评论数量
      isComment: false, // 控制弹出框是否显示
      commentValue: '',
      isSuspension: false, // 控制是否显示打开APP
      loading: true,
      // 唤起app
      extinfo: 'yslt://?name=artInfoDetail&',
      listload: false,
      finished: false,
      commentTotal: 0,
      likeTotal: 0, // 点赞数
      day_nl: '',
      month_nl: '',
      day: 0,
      month: 0,
      year: 0,
      week: '',
      lunarYearArr: [
        0x0b557, // 1949
        0x06ca0, 0x0b550, 0x15355, 0x04da0, 0x0a5b0, 0x14573, 0x052b0, 0x0a9a8, 0x0e950,
        0x06aa0, // 1950-1959
        0x0aea6, 0x0ab50, 0x04b60, 0x0aae4, 0x0a570, 0x05260, 0x0f263, 0x0d950, 0x05b57,
        0x056a0, // 1960-1969
        0x096d0, 0x04dd5, 0x04ad0, 0x0a4d0, 0x0d4d4, 0x0d250, 0x0d558, 0x0b540, 0x0b6a0,
        0x195a6, // 1970-1979
        0x095b0, 0x049b0, 0x0a974, 0x0a4b0, 0x0b27a, 0x06a50, 0x06d40, 0x0af46, 0x0ab60,
        0x09570, // 1980-1989
        0x04af5, 0x04970, 0x064b0, 0x074a3, 0x0ea50, 0x06b58, 0x055c0, 0x0ab60, 0x096d5,
        0x092e0, // 1990-1999
        0x0c960, 0x0d954, 0x0d4a0, 0x0da50, 0x07552, 0x056a0, 0x0abb7, 0x025d0, 0x092d0,
        0x0cab5, // 2000-2009
        0x0a950, 0x0b4a0, 0x0baa4, 0x0ad50, 0x055d9, 0x04ba0, 0x0a5b0, 0x15176, 0x052b0,
        0x0a930, // 2010-2019
        0x07954, 0x06aa0, 0x0ad50, 0x05b52, 0x04b60, 0x0a6e6, 0x0a4e0, 0x0d260, 0x0ea65,
        0x0d530, // 2020-2029
        0x05aa0, 0x076a3, 0x096d0, 0x04afb, 0x04ad0, 0x0a4d0, 0x1d0b6, 0x0d250, 0x0d520,
        0x0dd45, // 2030-2039
        0x0b5a0, 0x056d0, 0x055b2, 0x049b0, 0x0a577, 0x0a4b0, 0x0aa50, 0x1b255, 0x06d20,
        0x0ada0, // 2040-2049
        0x14b63, 0x09370, 0x049f8, 0x04970, 0x064b0, 0x168a6, 0x0ea50, 0x06b20, 0x1a6c4,
        0x0aae0, // 2050-2059
        0x0a2e0, 0x0d2e3, 0x0c960, 0x0d557, 0x0d4a0, 0x0da50, 0x05d55, 0x056a0, 0x0a6d0,
        0x055d4, // 2060-2069
        0x052d0, 0x0a9b8, 0x0a950, 0x0b4a0, 0x0b6a6, 0x0ad50, 0x055a0, 0x0aba4, 0x0a5b0,
        0x052b0, // 2070-2079
        0x0b273, 0x06930, 0x07337, 0x06aa0, 0x0ad50, 0x14b55, 0x04b60, 0x0a570, 0x054e4,
        0x0d160, // 2080-2089
        0x0e968, 0x0d520, 0x0daa0, 0x16aa6, 0x056d0, 0x04ae0, 0x0a9d4, 0x0a2d0, 0x0d150,
        0x0f252, // 2090-2099
        0x0d520 // 2100
      ],
      lunarMonth: ['正', '二', '三', '四', '五', '六', '七', '八', '九', '十', '冬', '腊'],
      lunarDay: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '初', '廿'],
      pageNoArt: 1,
      pageSizeArt: 1,
      totalPages: 0
    }
  },
  async created () {
    // 初始化数据
    // 获取url中的链接
    const url = await getUrlParams()
    this.id = url.id
    this.extinfo = this.extinfo + `id=${this.id}`
    // 获取咨询详情
    await this.getArtistInfo()
    await this.weixin()
    // 修改网页标题
    await changeTitleClick(this.artData.title)
    // 获取评论列表
    await this.queryCommentList()
    await this.queryCommentLikeTotal()
    await this.getRecWorksRandom()
    this.loading = false
  },
  mounted () {
    // 为所有img添加预览
    this.imgpreview()
    // 可以在这里面直接进行滚动条的获取
    window.addEventListener('scroll', this.scrollHandle)
  },
  methods: {
    toWorkDetail (id) {
      localStorage.setItem('___worksid', this.artInfo.id)
      const url = `http://room.yslt.art/SharePageTest/?id=${id}#/workDetail`
      window.location.href = url
    },
    async rollPage (index) {
      if (index === 0) {
        this.pageNoArt = 1
      } else {
        if (this.pageNoArt >= this.totalPages || this.pageNoArt <= 0) {
          // this.$tip.toast('没有更多了')
          return
        }
        this.pageNoArt += index
      }
      await this.getArtistLst()
      await this.getRecWorksRandom()
      document.getElementById('artinfo').scrollTop = 0
    },
    // 获取资讯列表
    async getArtistLst () {
      try {
        const res = await queryInformationList({ pageSize: this.pageSizeArt, pageNo: this.pageNoArt, tag: 1 })
        this.artData = res.result.records[0]
        this.totalPages = res.result.total
        this.artData.tag = 1
        if (this.artData.tag === 1) {
          const publishTime = this.artData.publishTime
          const time = publishTime.split(' ')
          const date = time[0]
          const dates = date.split('-')
          this.day = dates[2]
          this.month = dates[1]
          this.year = dates[0]
          const a = new Date(date)
          const h = a.getDay()
          var we = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
          this.week = we[h]
          this.sloarToLunar(this.year, this.month, this.day)
        }
      } catch (error) {
        console.log('获取资讯详情失败', error)
      }
    },
    // 获取资讯详情
    async getArtistInfo () {
      try {
        const res = await getartInfo({ id: this.id })
        this.artData = res.result
        if (this.artData.tag === '1') {
          this.extinfo = 'yslt://?name=microSignal'
          await this.getArtistLst()
        } else {
          this.artData.publishTime = this.$dayjs(this.artData.publishTime).format('YYYY-MM-DD hh:mm')
        }
      } catch (error) {
        console.log('获取资讯详情失败', error)
      }
    },
    sloarToLunar (sy, sm, sd) {
      // 输入的月份减1处理
      sm -= 1
      // 计算与公历基准的相差天数
      // Date.UTC()返回的是距离公历1970年1月1日的毫秒数,传入的月份需要减1
      let daySpan = (Date.UTC(sy, sm, sd) - Date.UTC(1949, 0, 29)) / (24 * 60 * 60 * 1000) + 1
      let ly, lm, ld
      // 确定输出的农历年份
      for (let j = 0; j < this.lunarYearArr.length; j++) {
        daySpan -= this.lunarYearDays(this.lunarYearArr[j])
        if (daySpan <= 0) {
          ly = 1949 + j
          // 获取农历年份确定后的剩余天数
          daySpan += this.lunarYearDays(this.lunarYearArr[j])
          break
        }
      }
      // 确定输出的农历月份
      for (let k = 0; k < this.lunarYearMonths(this.lunarYearArr[ly - 1949]).length; k++) {
        daySpan -= this.lunarYearMonths(this.lunarYearArr[ly - 1949])[k]
        if (daySpan <= 0) {
          // 有闰月时，月份的数组长度会变成13，因此，当闰月月份小于等于k时，lm不需要加1
          if (this.hasLeapMonth(this.lunarYearArr[ly - 1949]) && this.hasLeapMonth(this.lunarYearArr[ly - 1949]) <= k) {
            if (this.hasLeapMonth(this.lunarYearArr[ly - 1949]) < k) {
              lm = k
            } else if (this.hasLeapMonth(this.lunarYearArr[ly - 1949]) === k) {
              lm = '闰' + k
            } else {
              lm = k + 1
            }
          } else {
            lm = k + 1
          }
          // 获取农历月份确定后的剩余天数
          daySpan += this.lunarYearMonths(this.lunarYearArr[ly - 1949])[k]
          break
        }
      }
      // 确定输出农历哪一天
      ld = daySpan
      // 将计算出来的农历月份转换成汉字月份，闰月需要在前面加上闰字
      if (this.hasLeapMonth(this.lunarYearArr[ly - 1949]) && (typeof (lm) === 'string' && lm.indexOf('闰') > -1)) {
        lm = `闰${this.lunarMonth[/\d/.exec(lm) - 1]}`
      } else {
        lm = this.lunarMonth[lm - 1]
      }
      if (ld < 11) {
        ld = `${this.lunarDay[10]}${this.lunarDay[ld - 1]}`
      } else if (ld > 10 && ld < 20) {
        ld = `${this.lunarDay[9]}${this.lunarDay[ld - 11]}`
      } else if (ld === 20) {
        ld = `${this.lunarDay[1]}${this.lunarDay[9]}`
      } else if (ld > 20 && ld < 30) {
        ld = `${this.lunarDay[11]}${this.lunarDay[ld - 21]}`
      } else if (ld === 30) {
        ld = `${this.lunarDay[2]}${this.lunarDay[9]}`
      }
      this.day_nl = ld
      this.month_nl = lm
    },
    hasLeapMonth (ly) {
      // 获取16进制的最后1位，需要用到&与运算符
      if (ly & 0xf) {
        return ly & 0xf
      } else {
        return false
      }
    },
    // 如果有闰月，计算农历闰月天数，参数为存储农历年的16进制
    // 农历年份信息用16进制存储，其中16进制的第1位（0x除外）可以用于表示闰月是大月还是小月
    leapMonthDays (ly) {
      if (this.hasLeapMonth(ly)) {
        // 获取16进制的第1位（0x除外）
        return (ly & 0xf0000) ? 30 : 29
      } else {
        return 0
      }
    },
    // 计算农历一年的总天数，参数为存储农历年的16进制
    // 农历年份信息用16进制存储，其中16进制的第2-4位（0x除外）可以用于表示正常月是大月还是小月
    lunarYearDays (ly) {
      let totalDays = 0
      // 获取正常月的天数，并累加
      // 获取16进制的第2-4位，需要用到>>移位运算符
      for (let i = 0x8000; i > 0x8; i >>= 1) {
        const monthDays = (ly & i) ? 30 : 29
        totalDays += monthDays
      }
      // 如果有闰月，需要把闰月的天数加上
      if (this.hasLeapMonth(ly)) {
        totalDays += this.leapMonthDays(ly)
      }
      return totalDays
    },
    // 获取农历每个月的天数
    // 参数需传入16进制数值
    lunarYearMonths (ly) {
      const monthArr = []
      // 获取正常月的天数，并添加到monthArr数组中
      // 获取16进制的第2-4位，需要用到>>移位运算符
      for (let i = 0x8000; i > 0x8; i >>= 1) {
        monthArr.push((ly & i) ? 30 : 29)
      }
      // 如果有闰月，需要把闰月的天数加上
      if (this.hasLeapMonth(ly)) {
        monthArr.splice(this.hasLeapMonth(ly), 0, this.leapMonthDays(ly))
      }
      return monthArr
    },
    // 获取评论列表
    async queryCommentList () {
      try {
        const res = await queryCommentList({
          topicId: this.id,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        })
        this.commentTotal = res.result.total
        if (this.pageNo === 1) {
          this.artCommentList = res.result.records
        } else {
          this.artCommentList = [...this.artCommentList, ...res.result.records]
        }
        this.listload = false
      } catch (error) {
        console.log('获取评论列表失败', error)
      }
    },
    // 获取评论点赞
    async queryCommentLikeTotal () {
      try {
        const res = await queryCommentLikeTotal({
          topicId: this.id
        })
        this.likeTotal = res.result.likeCount
      } catch (error) {
        console.log('获取评论列表失败', error)
      }
    },
    // 随机获取作品
    async getRecWorksRandom () {
      try {
        const worksId = localStorage.getItem('___worksid')
        if (worksId) {
          localStorage.removeItem('___worksid')
          const res = await getWorksDetailById(worksId)
          this.artInfo = res.result
        } else {
          const res = await getRecWorksRandom({
            topicId: this.id
          })
          this.artInfo = res.result
        }
      } catch (error) {
        console.log('随机获取作品失败', error)
      }
    },
    // 给所有的img添加预览功能
    imgpreview () {
      console.log('执行')
      // 得到所有的img节点
      const articleContent = this.$refs.articleContent
      if (!articleContent) {
        return
      }
      try {
        const imgs = articleContent.querySelectorAll('img')
        console.log('图片列表', articleContent)
        const images = []
        imgs.forEach((img, index) => {
          images.push(img.src)
          img.onclick = () => {
            this.ImagePreview({
            // 预览的图片地址数组
              images,
              // 图片下标
              startPosition: index
            })
          }
        })
      } catch (error) {
        console.log('图片预览出现错误', error)
      }
    },
    previewImage (event) {
      if (event.target.tagName === 'IMG') {
        const urls = event.currentTarget.querySelectorAll('img')
        console.log('img', urls)
        if (event.target.alt) {
          this.$dialog({ message: '尊敬的用户\n如需购买商品,请先打开APP', confirmButtonText: '知道了', width: '300px' })
        } else {
          this.ImagePreview({
            images: [event.target.src]
          })
        }
      }
    },
    scrollHandle (e) {
      const top = e.srcElement.scrollingElement.scrollTop // 获取页面滚动高度
      if (top > 200) {
        this.isSuspension = true
      } else {
        this.isSuspension = false
      }
    },
    // 微信二次分享
    async weixin () {
      const res = await queryShart({ url: `${location.href.split('#')[0].toString()}` })
      console.log('分享参数', res)
      this.$nextTick(() => {
        wexinShare(res.result, {
          title: this.artData.title,
          desc: this.artData.content,
          link: `http://room.yslt.art/SharePageTest/?id=${this.id}#/artinfo`,
          imgUrl: 'http://artsss.oss-cn-hangzhou.aliyuncs.com/app/share1.png'
        })
      })
    },
    // 上拉加载评论
    async onLoad () {
      // 当前页数加1
      this.pageNo++
      // 调用获取数据的函数
      await this.queryCommentList()
      // 当数据总量大于或等于总页数时显示没有更多数据
      if (this.artCommentList.length >= this.total) {
        this.finished = true
      }
    },
    openAppErr () {
      window.open('https://a.app.qq.com/o/simple.jsp?pkgname=yslt.art.app', '_blank')
    },
    open () {
      window.open('http://room.yslt.art/art/openapp.html', '_blank')
    },
    share () {
      // this.open()
    },
    common () {
      // this.open()
    },
    like () {
      // this.open()
    }
  }
}
</script>

<style lang="scss" scoped>
.micro-info {
  background-color: #fff;
  padding-bottom: 56px;
 .micro-title {
    padding: 15px 20px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  .left {
    width: 50%;
    display: flex;
    align-items: flex-end;
  }
  .right {
    width: 50%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
  .day {
    font-size: 30px;
    font-weight: bold;
    color: #333;
    margin-right: 6px;
    display: flex;
    align-items: flex-end;
  }
  .month,
  .year,
  .week {
    font-size: 14px;
    font-weight: 400;
    color: #666;
    margin-bottom: 3px;
  }
  .nongli {
    font-size: 14px;
    font-weight: 400;
    color: #666;
    margin-bottom: 3px;
  }
 }
 .micro-box {
  margin: 0 auto;
  width: 100%;
  position: relative;
  background-color: #fff;
  .micro-content {
    text-align: center;
    padding: 0 20px;
    position: relative;
    .today-recommond {
      background-color: rgba(226, 67, 67, 0.9);
      border-top-right-radius: 6px;
      border-bottom-left-radius: 6px;
      font-size: 10px;
      color: #fff;
      display: inline-block;
      padding: 4px 8px;
      position: absolute;
      top: 0;
      right: 20px;
      z-index: 999;
    }
    .recommond-img-box {
        height: 180px;
        width: 100%;
        border-radius: 6px;
        overflow: hidden;
      .recommond-img {
        height: 180px;
        width: 100%;
        display: block;
        margin: 0 auto;
      }
    }
    >span {
      display: block;
      font-size: 12px;
      font-weight: 400;
      color: #999;
      margin-top: 10px;
    }
    .micro-html {
      padding: 15px 0;
    }
  }
 }
 .page-view {
  padding: 0 20px;
  position: fixed;
  bottom: 0;
  height: 56px;
  width: 100%;
  border-top: 1px solid #EEEEEE;
  background-color: #fff;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .page-left {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      height: 8px;
      width: 5px;
    }
    .pre-page, .next-page {
      height: 32px;
      width: 76px;
      font-size: 12px;
      font-weight: bold;
      color: #C4946B;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid rgba(196, 148, 107, 0.5);
    }
    .pre-page {
      img {
        margin-right: 10px;
        transform: rotateY(180deg);
      }
    }
    .next-page {
      margin-left: 15px;
      img {
        margin-left: 10px;
      }
    }
  }
  .page-right {
    width: 50%;
    display: flex;
    justify-content: flex-end;
    .today-page {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 32px;
      width: 76px;
      font-size: 12px;
      font-weight: bold;
      color: #fff;
      background-color: #C4946B;
    }
  }
 }
}
.arthtml {
  min-height: 100vh;
  ::v-deep {
    div{
     max-width: 100% !important;
     height: 100% !important;
    }
    img {
     max-width: 100% !important;
     height: 100% !important;
    }
    table,tbody,td,tr {
      max-width: 100% !important;
     height: 100% !important;
    }
    section {
      max-width: 100% !important;
      height: 100% !important;
    }
  }
}
.h1 {
  font-size: 24px;
  line-height: 35px;
  padding-top: 22px;
}
.art-time {
  font-size: 12px;
  color: #b8b8b8;
  display: inline-block;
}
.division {
  padding-left: 10px;
  margin-left: 10px;
}
.division {
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    width: 1px;
    height: 12px;
    transform: translateY(-50%);
    background-color: #B8B8B8;
  }
}
.microsignal {
  padding: 10px;
  background-color: #e9f5d9;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 2px;
}
.info-video {
  width: 100%;
  >video {
    width: 100%;
  }
}
.artinfo {
  overflow: hidden;
  background: #f2f2f2;
  .artinfo-main,
  .artinfo-comment {
    padding: 0 18px 52px;
    background: #fff;
  }
  .ar-bot {
    text-align: center;
  }
}
.CommentTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  margin-top: 10px;
  .right {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    flex: 1;
  }
  .page-view,
  .like-conut {
    font-size: 13px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }

  .hx {
    width: 1px;
    height: 13px;
    background: #b8b8b8;
    margin: 0 10px;
  }
}

.uni-padding-wrap {
  margin-top: 10px;
  div {
    font-size: 14px;
  }

  .uni-comment {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
  }

  .uni-comment-replay-btn {
    background: #fff;
    font-size: 12px;
    line-height: 14px;
    padding: 5px 10px;
    border-radius: 15px;
    color: #333 !important;
    margin: 0 5px;
  }
}
.suspension {
  width: 153px;
  height: 45px;
  background: rgba(196, 148, 107, 0.9);
  font-size: 16px;
  color: #fff;
  position: fixed;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  > span {
    margin-left: 6px;
  }
}
</style>
